import React from 'react';
import SocialscienceCCA2023 from 'views/SocialscienceCCA2023';

const HumanityClubPage = () => {
  return <SocialscienceCCA2023 />;
};

export default HumanityClubPage;